import React, { useContext } from "react";
import { AuthContext } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { Settings as IconSettings, Blinds, BookMarked, UserRoundPlus,
  Settings2, CalendarPlus2, BetweenHorizontalStart, BookType, Link
} from "lucide-react";
import { gerarTokenTelegram } from "../api";


export default function Settings() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const handleSetTelegram = async () => {
    try {
      const data = await gerarTokenTelegram(user.token); // token do usuário logado
      
      const telegramToken = data.token;
      console.log(telegramToken);

      window.open(
        `https://t.me/BesAssistBot?start=${telegramToken}`,
        "_blank"
      );

    } catch (err) {
      console.error(err);
      alert("Erro ao conectar Telegram");
    }
  };

  /* Correção IOS Safari
  const handleSetTelegram = async () => {
    try {
      const newWindow = window.open("", "_blank"); // abre imediatamente

      const data = await gerarTokenTelegram(user.token);
      const telegramToken = data.token;

      newWindow.location.href = `https://t.me/BesAssistBot?start=${telegramToken}`;

    } catch (err) {
      console.error(err);
      alert("Erro ao conectar Telegram");
    }
  };
  */

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <h3><IconSettings size={20} /> Configurações</h3>
            <div className="card-actions">
              <button
                className="btn-primary"
                onClick={() => navigate("/settingsadjust")}
              >
                <Settings2 size={20} /> Configurações Gerais
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/addeventos")}
              >
                <CalendarPlus2 size={20} /> Cadastrar Evento
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/addtipos")}
              >
                <BookType size={20} /> Cadastrar Tipos
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/addtables")}
              >
                <BetweenHorizontalStart size={20} /> Cadastrar Tabelas
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/families")}
              >
                <BookMarked size={20} /> Cadastrar Famílias
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/products")}
              >
                <Blinds size={20} /> Cadastrar Produtos
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/register")}
              >
                <UserRoundPlus size={20} /> Cadastrar Usuários
              </button>
              <button
                className="btn-primary"
                onClick={handleSetTelegram}
              >
                <Link size={20} /> Vincular Telegram
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
